var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.4219 16L28.2031 26.7969L26.7969 28.2031L16 17.4219L5.20312 28.2031L3.79688 26.7969L14.5781 16L3.79688 5.20312L5.20312 3.79688L16 14.5781L26.7969 3.79688L28.2031 5.20312L17.4219 16Z","fill":"currentColor"}));
}

CloseInline.defaultProps = {"viewBox":"0 0 32 32","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
